export default class ModalInformationBoForm extends HTMLDivElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initEvents();

        this.displayInputFile($('[name="type"]').val());
        this.displayCategoryTypeField($('[name="category_type"]').val());
    }

    initEvents() {
        var localThis = this;

        $('[name="type"]').on('change', function(e) {
            localThis.displayInputFile($(this).val());
        });

        $('[name="category_type"]').on('change', function(e) {
            localThis.displayCategoryTypeField($(this).val());
        });
    }

    displayInputFile(type) {
        $("[data-show-type]").each((key, item) => {
            if($(item).data('show-type') == type)
            {
                $(item).parents('.form-group').show();
            }else{
                $(item).parents('.form-group').hide();
            }
        })
    }

    displayCategoryTypeField(categoryType) {
        $('[data-show-category-type]').each((key, item) => {
            const $item = $(item);
            const isVisible = $item.data('show-category-type') == categoryType;
            $item.toggle(isVisible);
            $item.find('select').prop('required', isVisible);
        });
    }
}